import React, { useState } from 'react'
import {
  Modal,
  Card,
  Col,
  Row,
  Collapse,
  Dropdown,
  Avatar,
  List,
  Spin,
  Button
} from 'antd'
import ds from '../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import { loadSellSelectedAttributes } from '../../appRedux/actions/Sell'
import {
  closeAttribModal,
  closeAttribTabsModal,
  formatDigits,
  getDecryptID,
  getRandomInt,
  isEmptyObject,
  loadDropDownStates,
  notAllowMsgCheck,
  parkSale
} from '../../appRedux/actions'
import {
  CaretRightOutlined,
  HistoryOutlined,
  ShoppingCartOutlined,
  WalletOutlined
} from '@ant-design/icons'
import ParkRetrieveListItem from './ParkRetrieveListItem'
import moment from 'moment'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import Placeholder from '../../assets/images/placeholder.svg'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'
import { ATTRIB_MODAL_TYPES } from '../../constants/MobAppConstants'

const { Panel } = Collapse
const confirm = Modal.confirm

const SellAttribCardForTabs = props => {
  const {
    d,
    selectedID,
    id,
    hours,
    minutes,
    currency,
    keyy,
    setData,
    setShow,
    setName
  } = props
  const dispatch = useDispatch()

  const sellAttributesGroups = useSelector(
    ({ Sell }) => Sell.sellAttributesGroups
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const dropDownStates = useSelector(
    ({ commonConfigs }) => commonConfigs.dropDownStates
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const mountSellAttribTabs_type = useSelector(
    ({ Sell }) => Sell.mountSellAttribTabs_type
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)

  const [getIsSpinning, setIsSpinning] = useState(true)
  const [saleData, setSaleData] = useState({})
  const [activeKey, setActiveKey] = useState('')

  function onAttribClick (e) {
    if (mountSellAttribTabs_type == ATTRIB_MODAL_TYPES.PARK_SALE) {
      const currSale =
        getCurrentSalesOrderData &&
        !isEmptyObject(getCurrentSalesOrderData) &&
        getCurrentSalesOrderData.E_SalesOrderID
      let showPop = e && e.inProgress
      if (currSale) {
        const exist =
          e && e.sales && e.sales.length > 0
            ? e.sales.filter(a => a.saleOrderID == getDecryptID(currSale))
            : []
        if (exist && exist.length > 0) showPop = false
      }
      if (showPop) {
        showConfirm(e)
      } else {
        onProceed(e)
      }
    }
  }

  function onProceed (e) {
    const group = sellAttributesGroups.filter(
      a => getDecryptID(a.groupID) == getDecryptID(e.groupID)
    )
    let sellAttribs = false
    if (group && group.length > 0) {
      const selGroup = group[0]
      const selAttrib =
        sellSelAttributes && sellSelAttributes.length > 0
          ? sellSelAttributes
          : []
      const body = {
        sellAttribID: getRandomInt(100000000),
        groupID: e.groupID ? e.groupID : '',
        attributeID: e.attributeID ? e.attributeID : '',
        groupName: selGroup.title ? selGroup.title : '',
        attributeName: e.title ? e.title : '',
        inProgress: e.inProgress ? e.inProgress : false
      }
      let postBody = body
      // // // NOTE: FOR ONLY ALLOWED SINGLE ATTRIB SELECT
      // if (
      //   selAttrib &&
      //   selAttrib.length > 0 &&
      //   selAttrib.filter(
      //     cc =>
      //       getDecryptID(cc.groupID) == getDecryptID(postBody.groupID) &&
      //       getDecryptID(cc.attributeID) == getDecryptID(postBody.attributeID)
      //   ).length > 0
      // ) {
      //   postBody = selAttrib.filter(
      //     cc =>
      //       cc.groupID == postBody.groupID &&
      //       cc.attributeID == postBody.attributeID
      //   )[0]
      // }
      // // // NOTE END
      if (
        selAttrib.filter(
          q => getDecryptID(q.attributeID) == getDecryptID(body.attributeID)
        ).length > 0
      ) {
        sellAttribs = selAttrib
      } else {
        sellAttribs = selAttrib.concat(postBody)
      }
      dispatch(loadSellSelectedAttributes(sellAttribs))
    }
    // dispatch(loadIsShowSellAttribute(false))
    closeAttribModal(dispatch, dropDownStates)
    closeAttribTabsModal(dispatch, dropDownStates)

    // // //NOTE: PARKING SALE IF EXIST
    if (
      getSaleOrderJson &&
      getCurrentSalesOrderData &&
      !isEmptyObject(getSaleOrderJson) &&
      !isEmptyObject(getCurrentSalesOrderData)
    ) {
      handleClickParkedSale(sellAttribs ? sellAttribs : sellSelAttributes)
    }
  }

  const handleClickParkedSale = postData1 => {
    if (isOnline && getSaleOrderJson.indexKey) {
      const checkParked = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.SALES
      )
      checkParked
        .then(async e => {
          const saleExist = e.filter(
            q =>
              q.indexKey == getSaleOrderJson.indexKey &&
              q.isOffline &&
              q.isParked
          )
          if (saleExist && saleExist.length > 0) {
            parkSaleFn(postData1, false)
          } else parkSaleFn(postData1, isOnline)
        })
        .catch(e => {
          parkSaleFn(postData1, isOnline)
          // console.log('INDEX_DB_ERROR -> forceUpdateIndexSales -->', e)
        })
    } else {
      parkSaleFn(postData1, isOnline)
    }
  }

  function parkSaleFn (postData1, pretendOnline) {
    parkSale(
      getSaleOrderJson,
      getSalesOrderStatuses,
      getCurrentSalesOrderData,
      {},
      getIsRefundSale,
      dispatch,
      getReduxSalePaymentData,
      postData1, // sellSelAttributes,
      !getIsSalePaymentProcessStart ? sellActionLog : [],
      getDeletedProds ? getDeletedProds : [],
      pretendOnline
    )
  }

  function showConfirm (e) {
    confirm({
      title: `${e.title ? e.title : 'This space'} is already in use.`,
      content: `Are you sure you want to continue?`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk () {
        onProceed(e)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }
  
  return (
    d && (
      <Card
        hoverable
        className={`${
          id == selectedID || d.inProgress
            ? 'ant-attribcard-bordered-active'
            : 'ant-regcard-bordered-deactive'
        } dk-attribute-card reservation-cards`}
        onClick={() => onAttribClick(d)}
        key={keyy}
      >
        <div className='Register-cart'>
          <h3 className='mb-0'>{d.title}</h3>
          {d.inProgress ? (
            <div className='sell-attrib-footer' onClick={w => w.stopPropagation()} >
              <p className='mb-0 mt-1'> In Use </p>
              {mountSellAttribTabs_type == ATTRIB_MODAL_TYPES.RETRIEVE_SALE && (
               
                  <Button
                    className='plan-btn mt-2'
                    type='primary'
                    block
                    onClick={e => {
                      let allow = d.isOffline ? d.isOffline : d.saleOrderID
                      if (allow) {
                        setData(d)
                        setShow(true)
                        setName(d.title)
                      }
                    }}
                  >
                    {`${
                      d.saleCount && d.saleCount > 0 ? d.saleCount : 1
                    } Parked ${
                      d.saleCount && d.saleCount > 1 ? 'Sales' : 'Sale'
                    }`}
                  </Button>
              
              )}
            </div>
          ) : (
            <p style={{ display: 'none' }} className='custom-addpromo-hidetext'>
              a
            </p>
          )}
        </div>
      </Card>
    )
  )
}

export default SellAttribCardForTabs
